import { render, staticRenderFns } from "./UzMap.vue?vue&type=template&id=39f39c79&"
import script from "./UzMap.vue?vue&type=script&lang=js&"
export * from "./UzMap.vue?vue&type=script&lang=js&"
import style0 from "./UzMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports